import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { graphql } from "gatsby";
import SEO from "../components/seo";
import ThisIsMdx from "./this-is-mdx.mdx";
export const query = graphql`
  query MyMoreMDXQuery {
    allMdx {
      edges {
        node {
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            path
            featuredImage {
              id
            }
          }
          exports {
            metadata {
              author
              title
              path
              date
              featuredImage {
                id
              }
            }
          }
        }
      }
    }
  }
`;
export const _frontmatter = {
  "title": "This is More MDX",
  "date": "2019-01-30T00:00:00.000Z",
  "author": "Kathleen McMahon",
  "path": "/this-is-more-mdx",
  "featuredImage": "../images/disney-cruise-bar.jpg"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodePen = makeShortcode("CodePen");
const layoutProps = {
  query,
  _frontmatter
};

const MDXLayout = ({
  children
}) => <>{children}</>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title={props.pageContext.frontmatter.title} mdxType="SEO" />
    <h1>Frontmatter title {props.pageContext.frontmatter.title}</h1>
    <p>Frontmatter author{props.pageContext.frontmatter.author}</p>
    <hr></hr>
    <h2>{`Can you write more MDX and import a separate MDX file?`}</h2>
    <p>{`Yes you can! This page is an MDX file that is importing another MDX file. This page uses a default export, so it won't take on the default layout set by the gatsby-config file.`}</p>
    <p>{`This page is also exporting metadata through a const and through a GraphQL export query. Need to double check this one.`}</p>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/kathleenmcmahon/image/upload/q_auto,f_auto/v1587501269/100-days-of-gatsby-cloudinary/castaway-key-umbrellas-closeup.jpg",
        "alt": "Colorful group of umbrellas nestled on the soft tropical sands of Castaway Cay"
      }}></img></p>
    <h3>{`And a CodePen embed`}</h3>
    <CodePen codePenId="eYOQQxY" mdxType="CodePen" />
    <h3>{`Where is the imported shortcode?`}</h3>
    <p>{`It is imported right below this. Good times.`}</p>
    {
      /* This default export overrides the default layout set in the
      gasby-config.js file ensuring that the FAQ component isn't wrapped
      by other elements */
    }
    <p>{`Passing children into the `}<inlineCode parentName="p">{`<ThisIsMdx/>`}</inlineCode>{` component/shortcode below does nothing, because it is an MDX file.`}</p>
    <ThisIsMdx children={`Testing456`} mdxType="ThisIsMdx">Testing 123</ThisIsMdx>


    {
      /* query MdxExports {
       allMdx {
         nodes {
           exports {
             metadata {
               name
               author
             }
           }
         }
       }
      } */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      